export default __webpack_public_path__ + "static/media/1835.b5caa7f8.png";